import { render } from "./presenca-visual-professor.vue?vue&type=template&id=074c90ba&scoped=true"
import script from "./presenca-visual-professor.vue?vue&type=script&lang=js"
export * from "./presenca-visual-professor.vue?vue&type=script&lang=js"

import "./presenca-visual-professor.vue?vue&type=style&index=0&id=074c90ba&lang=scss&scoped=true"
import "./presenca-visual-professor.vue?vue&type=style&index=1&id=074c90ba&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074c90ba"]])

export default __exports__